import React from "react";
import { useTheme } from "../Components/theme/ThemeContext.jsx";
import Reviews from "../Components/Reviews.jsx";
import { Link } from "react-router-dom";

function About() {
  const { theme } = useTheme();
  const isLightTheme = theme === "light";
  const containerStyle = {
    background: theme === "retro"
      ? "linear-gradient(to bottom, #0B1305 0%, #00008B 100%)"
      : isLightTheme ? "#FFFFFF" : "#1E1E1E",
    color: isLightTheme ? "#000000" : "#FFFFFF",
    minHeight: "100vh",
    padding: "20px",
  };
  const dividerColor = isLightTheme ? "#000000" : "#FFFFFF";

  return (
    <div style={containerStyle} className="container text-center p-4">
      <div className="container my-4">
        <div className="row">
          <div className="col-md-6">
            <div className="jumbotron text-center">
              <h1 className="display-4">Welcome to Friendly Bets - Where Every Game Counts!</h1>
              <p className="lead">Experience the thrill of friendly betting in a fun, safe, and engaging environment.</p>
            </div>
          </div>
        </div>
      </div>

      <div className="line-divider" style={{ borderTop: `1px solid ${dividerColor}` }} />

      <div className="container p-4">
        <h2>Our Mission: Enhancing Your Game-Watching Experience</h2>
        <p>
          Friendly Bets makes sports and games more exciting through friendly wagers. Whether it is a cup of coffee or a custom challenge, the goal is to stay connected, enjoy the game, and keep game-day traditions alive with the people who matter most.
        </p>
      </div>

      <div className="line-divider" style={{ borderTop: `1px solid ${dividerColor}` }} />

      <div className="container p-5">
        <h2>How Friendly Bets Works</h2>
        <div className="row">
          <div className="col-md-4"><h3>Create a Bet</h3><p>Start with a game and make it your own.</p></div>
          <div className="col-md-4"><h3>Invite Friends</h3><p>Challenge friends and keep the conversation going.</p></div>
          <div className="col-md-4"><h3>Track and Win</h3><p>Follow the result and settle the friendly wager.</p></div>
        </div>
      </div>

      <div className="line-divider" style={{ borderTop: `1px solid ${dividerColor}` }} />
      <Reviews />

      <footer className="text-center p-4">
        <div className="mb-3">
          <Link to="/mini-games" className="btn btn-outline-primary btn-lg" style={{ textDecoration: "none", borderWidth: "2px", fontWeight: "bold" }}>
            Play Mini Games
          </Link>
        </div>
        <p>&copy; 2026 Friendly Bets. All rights reserved.</p>
      </footer>
    </div>
  );
}

export { About };